type InvestmentCalculatorProps = {
  standard: string;
};
export function InvestmentCalculator({ standard }: InvestmentCalculatorProps) {
  return (
    <euroland-tool
      data-tool-name="InvestmentCal2"
      data-tool-language={standard}
    />
  );
}
